export var EncChannel;
(function (EncChannel) {
    function isBasic(channel) {
        switch (channel) {
            case 'row':
            case 'column':
            case 'value':
            case 'filter': {
                return true;
            }
            default: {
                return false;
            }
        }
    }
    EncChannel.isBasic = isBasic;
    function isMark(channel) {
        switch (channel) {
            case 'baseline':
            case 'color':
            case 'size':
            case 'label':
            case 'text':
            case 'detail':
            case 'tooltip':
            case 'angle': {
                return true;
            }
            default: {
                return false;
            }
        }
    }
    EncChannel.isMark = isMark;
})(EncChannel || (EncChannel = {}));
